// import Configs from "../models/Configs";

import {every, isNull, isPlainObject, isString} from "lodash";
import {saveAs} from 'file-saver';
import moment from "moment";
import {convertMinsToHrsMins_v2} from "../lib/Util";

export function test() {
	return null;
}

export function getOS() {
	const { userAgent } = window.navigator;
	const { platform } = window.navigator;
	const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
	const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
	const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
	let os = null;

	if (macosPlatforms.indexOf(platform) !== -1) {
		os = 'MacOS';
	} else if (iosPlatforms.indexOf(platform) !== -1) {
		os = 'iOS';
	} else if (windowsPlatforms.indexOf(platform) !== -1) {
		os = 'Windows';
	} else if (/Android/.test(userAgent)) {
		os = 'Android';
	} else if (!os && /Linux/.test(platform)) {
		os = 'Linux';
	}

	document.documentElement.setAttribute('os', os);
	// Configs.setOs(os.toLowerCase());
	return os.toLocaleLowerCase();
}

export const hasNotch = () => {
	/**
	 * For storybook test
	 */
	const storybook = window.location !== window.parent.location;
	const iPhone = /iPhone/.test(navigator.userAgent) && !window.MSStream;
	const aspect = window.screen.width / window.screen.height;
	const aspectFrame = window.innerWidth / window.innerHeight;
	return (
		(iPhone && aspect.toFixed(3) === '0.462') ||
		(storybook && aspectFrame.toFixed(3) === '0.462')
	);
};

export const mergeRefs = (refs) => (value) => {
	refs.forEach((ref) => {
		if (typeof ref === 'function') {
			ref(value);
		} else if (ref != null) {
			const newRef = ref;
			newRef.current = value;
		}
	});
};

export const randomColor = () => {
	const colors = ['primary', 'secondary', 'success', 'info', 'warning', 'danger'];

	const color = Math.floor(Math.random() * colors.length);

	return colors[color];
};

export const priceFormat = (price) => price.toLocaleString('en-US', {
	style: 'currency',
	currency: 'USD',
});

export const average = (array) => array.reduce((a, b) => a + b) / array.length;

export const percent = (value1, value2) => ((value1 / value2 - 1) * 100).toFixed(2);

export const getFirstLetter = (text, letterCount = 2) =>
	text
		.toUpperCase()
		.match(/\b(\w)/g)
		.join('')
		.substring(0, letterCount);

export const debounce = (func, wait = 1000) => {
	let timeout;

	return function executedFunction(...args) {
		const later = () => {
			clearTimeout(timeout);
			func(...args);
		};

		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
	};
};

export const createFormDataFromObject = (data) => {
	const formData = new FormData();
	for (const key in data) {
		if (Reflect.has(data, key)) {
			const items = isNull(data[key]) ? '' : data[key];

			if (isPlainObject(items)) {
				formData.append(key, JSON.stringify(items));
			}
			else if (Array.isArray(items)) {
				// Stringify array containing plain objects
				if (every(items, isPlainObject) || every(items, isString)) {
					formData.append(key, JSON.stringify(items));
				} else {
					// In case of non-plain object, such as `File` object
					items.forEach((item, index) => {
						formData.append(`${key}[${index}]`, item);
					});
				}
			} else {
				formData.append(key, items);
			}
		}
	}
	return formData;
};


export const saveFileAs = (data, filename) => {
	const file = new Blob([data], {
		type: 'text/plain;charset=utf-8',
	});

	saveAs(file, filename);
};

export const createDownloadFileName = (rawText = '') => {
	try {
		let fmDecode = decodeURIComponent(rawText);

		if (fmDecode.startsWith('"')) {
			fmDecode = fmDecode.slice(1);
		}

		if (fmDecode.endsWith('"')) {
			fmDecode = fmDecode.slice(0, fmDecode.length - 1);
		}

		return fmDecode.replaceAll('+', ' ');
	} catch (e) {
		console.error(e);

		return rawText;
	}
};

export function renameMultipleRootKeys(obj, keyMap) {
	const result = {};
	for (const key in obj) {
		if (Object.prototype.hasOwnProperty.call(obj, key)) {
			const newKey = keyMap[key] || key;
			result[newKey] = obj[key];
		}
	}
	return result;
}

export function roundNumber(num, m = 2) {
	if (!Number.isFinite(num) || !Number.isInteger(m) || m < 0) {
		return num;
	}
	return Number.isInteger(num) ? num : Math.round(num * (10 ** m)) / (10 ** m);
}

export function countWorkDays(startDate, endDate, workDays) {
	// check valid
	if (
		!startDate ||
		!endDate ||
		Number.isNaN(Date.parse(startDate)) ||
		Number.isNaN(Date.parse(endDate)) ||
		!Array.isArray(workDays) ||
		workDays.some(d => d < 0 || d > 6 || !Number.isInteger(d))
	) {
		return 0;
	}

	let count = 0;
	const current = new Date(startDate);
	const end = new Date(endDate);
	while (current <= end) {
		if (workDays.includes(current.getDay())) count++;
		current.setDate(current.getDate() + 1);
	}
	return count;
}

export function translateValueToKorean(value) {
	let key = '';
	switch (value) {
		case 'Name':
		case 'Tên':
			key = '이름';
			break;
		case 'Email':
			key = '이메일';
			break;
		case 'Used start date':
		case 'Ngày bắt đầu sử dụng':
			key = '사용 시작일자';
			break;
		case 'Ngày kết thúc sử dụng':
		case 'Used end date':
			key = '사용 종료일자';
			break;
		case 'Vacation Type':
		case 'Loại kỳ nghỉ':
			key = '휴가유형';
			break;

	}
	return key;
}

export function translateObjectKeysToKorean(inputObj) {
	const result = {};
	for (const key in inputObj) {
		if (Object.prototype.hasOwnProperty.call(inputObj, key)) {
			const translatedKey = translateValueToKorean(key);
			result[translatedKey] = inputObj[key];
		}
	}
	return result;
}

export function translateArrayOfObjectsToKorean(inputArray) {
	return inputArray.map(translateObjectKeysToKorean);
}

export const isMobileDevice = () => {
	return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
		.test(navigator.userAgent);
}

export function formatDateRange(startDateStr, startTimeStr, endDateStr, endTimeStr, t, workTime = 0, isNightWork = false) {
	const start = moment(
		`${startDateStr.split('T')[0]}T${startTimeStr}`,
		'YYYY-MM-DDTHH:mm'
	);

	const end = moment(
		`${endDateStr.split('T')[0]}T${endTimeStr}`,
		'YYYY-MM-DDTHH:mm'
	);

	if (start.isSame(end, 'day') || isNightWork) {
		return `${start.format('YYYY-MM-DD (ddd)')} [${convertMinsToHrsMins_v2(workTime || end.diff(start, 'seconds'))}]`;
	}

	return `${start.format('YYYY-MM-DD (ddd)')} ~ ${end.format('YYYY-MM-DD (ddd)')} [${convertMinsToHrsMins_v2(workTime || end.diff(start, 'seconds'))}]`;
}

export function validateIPv4OrCIDR(input, trans) {
	const ipRegex =
		/^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/;

	if (typeof input !== 'string') {
		return { valid: false, message: trans('invalidType') };
	}

	if (input.includes('/')) {
		const parts = input.split('/');
		if (parts.length !== 2) {
			return { valid: false, message: trans('invalidCIDRFormat') };
		}

		const [ip, mask] = parts;

		if (!ipRegex.test(ip)) {
			return { valid: false, message: trans('invalidIP') };
		}

		const maskNum = parseInt(mask, 10);
		if (isNaN(maskNum) || maskNum < 0 || maskNum > 32) {
			return { valid: false, message: trans('invalidMask') };
		}

		return { valid: true, message: trans('validCIDR') };
	}

	if (!ipRegex.test(input)) {
		return { valid: false, message: trans('invalidIP') };
	}

	return { valid: true, message: trans('validIP') };
}